<template>
<!--  v-if=" ! route().current(router)" -->
<q-menu context-menu v-if="!disable">
        <!-- <q-item clickable @click="open(route(router))" v-close-popup dense> -->
        <!-- <q-item clickable @click="open(setLink())" v-close-popup dense> -->
        <q-item clickable @click="open(router)" v-close-popup dense>
            <q-item-section>
                <q-item-label>Ouvrir dans un nouvel onglet</q-item-label>
            </q-item-section>
            <q-item-section side>
                <q-icon name="open_in_new" size="xs" color="grey" />
            </q-item-section>
        </q-item>
</q-menu>
</template>

<script setup>
import { open } from '@helpers'

const props = defineProps({
    router: {String, default: 'welcome'},
    disable: Boolean,
})



// export default {
//     name: 'OpenInNewTab',
//     props:{
//         router: {String, default: 'welcome'},
//         // params: null,//{default: null}
//     },
//     setup(props){
//         return {
//             open,

//             setLink: ()=>{

//                 if(props.params){
//                     return route(props.router, props.params)
//                 }

//                 return route(props.router)
//             }
//         }
//     },
// }
</script>
